import { render } from "./SalesReturnList.vue?vue&type=template&id=6f328e20"
import script from "./SalesReturnList.vue?vue&type=script&lang=js"
export * from "./SalesReturnList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__